import React, {PropTypes} from 'react';
import './confirm_details.less';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../../auth/auth_actions';
import requestAnItemActions from '../request_an_item_actions';
import moment from 'moment';
import validate from '../../util/validate';
import {Link, browserHistory} from 'react-router';
import LoggedinFooter from '../../footer/loggedin_footer';
import CONSTANTS from '../../common_constants';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../../util/common';

class ConfirmDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ajaxInProgress : false
    }
    window.scrollTo(0,0);
  }
  goBack = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/request-an-item/delivery-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/request-an-item/delivery-details');
  }
  componentDidMount(){
    if(validate.isEmpty(this.props.requestAnItem))
        browserHistory.push('/request-an-item');
    const shipmentId = this.props.location.query.shipmentId;
    this.setState({
          shipmentId
    })
  }
  saveAsDraft = () =>{
    let parameters = Object.assign({} , this.props.requestAnItem);
    parameters.shipmentStatus = 1;
    parameters.shipmentType = 2 ; //request an item
    parameters.deliveryDate = localTimestampToGMT(parameters.deliveryDate)
    let value = moment(parameters.deliveryDate)
    if(value.startOf('day').diff(moment().startOf('day') , 'days') == 0)   //check if selected date is today
    {
        parameters.deliveryDate = (new Date(value.unix()*1000).setHours(23,59,59,0))  //store end of the day with 1 minutes less
    }
    let API = "CREATE";
    if(this.state.shipmentId)
      API = "UPDATE"
    this.setState({ajaxInProgress: true});
    this.props.requestAnItemActions.createAshipment(parameters,API).then(() => {
        this.setState({ajaxInProgress: false});
        browserHistory.push('/dashboard/i-am-shipping');
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
    })
  }
  submit = () =>{

    const {userData} = this.props.authState;
    if(userData.email) amplitude.getInstance().setUserId(userData.email);
    amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.REQ_ITEM_PAYMENT_START);

    if(this.state.shipmentId)
      browserHistory.push('/request-an-item/payment?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/request-an-item/payment');
  }
  render() {
    const {requestAnItem} = this.props ;
    const defaultImgUrl = "../../../public/images/requester_flow/placeholder.png"
    let imgURL = requestAnItem.imageIds ? (requestAnItem.imageIds.length > 0 ? requestAnItem.imageIds[0] : defaultImgUrl ) : defaultImgUrl;
    const loader = <div className="loader"></div>;
    return (
      <div id="confirDetailsWrap">
        <div className = "wrapper confirm-details-wrap">
          <div className="back-section" onClick = {this.goBack}>
              <span className="icon-icn_back"></span>
              <span className = "back-content">Back</span>
          </div>
          <div className ="confirm-details">
          <div className="title-div">
            <div className="title-div-img" style={{"backgroundImage": 'url("' + imgURL + '")'}}></div>
            <div className="title-div-content">
              <div className="title-heading">
                {requestAnItem.title}
                </div>
              <div className="title-location">Delivery to {requestAnItem.deliveryCity ? requestAnItem.deliveryCity+", " : ""} {requestAnItem.deliveryCountry}</div>
              <div className="title-cost">${requestAnItem.shipmentCost + requestAnItem.itemValue}</div>
            </div>
          </div>
          <div className="delivery-section">
            <div className ="calender-icon">
              <span className ="icon-calendar"></span>
            </div>
            <div className="delivery-by-content">
              <div className="delivery-by">
                Delivery by
              </div>
              <div className ="delivery-date">
                {moment(requestAnItem.deliveryDate).format("ll")}
              </div>
            </div>
          </div>
          <div className="delivery-section no-border">
            <div className ="calender-icon">
              <span className="icon-downarrow"></span>
            </div>
            <div className="delivery-by-content">
              <div className="delivery-by">
                Delivery location
              </div>
              <div className ="delivery-date">
                {requestAnItem.deliveryLocation}
              </div>
            </div>
          </div>
          <div className = "submit-section">
            <div className = "submit-options">
                <button className = "btn orange" onClick = {this.submit} >Proceed to Payment</button>
            </div>
            <div className = "submit-options m-l">
                <button className = "btn green" onClick = {this.saveAsDraft} >{this.state.ajaxInProgress? loader : 'Save and Exit'}</button>
            </div>
          </div>
        </div>
      </div>
      <LoggedinFooter/>
    </div>
    )
  }
}

ConfirmDetails = connect((state) => {
  return {
    requestAnItem : state.app.requestAnItem,
    authState : state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    requestAnItemActions :bindActionCreators(requestAnItemActions, dispatch)
  }
})(ConfirmDetails);

export default ConfirmDetails;



// WEBPACK FOOTER //
// app/request_an_item/confirm_details/confirm_details.jsx